export const X_B2B_CLIENT_ID = 'X-B2b-Client-Id'
export const X_TAXI = 'x-taxi'
